import * as React from 'react';
import { forwardRef } from 'react';

import cn from 'classnames';

export type InputFormControlType = HTMLInputElement;
export type InputFormControlProps = React.InputHTMLAttributes<HTMLInputElement>;

export const InputFormControl = forwardRef<InputFormControlType, InputFormControlProps>(
  ({ className, ...props }, ref) => <input ref={ref} className={cn('form-control', className)} {...props} />,
);
